import { derived } from "svelte/store";
import journey from "./journey.js";

const MINIMUM_UPDATE_INTERVAL_MILLISECONDS = 300;

function createPathStore(route) {
	let lastUpdateAt = 0;

	return derived([journey], ([$journey], set) => {
		if (!route || !$journey.location || Date.now() - lastUpdateAt < MINIMUM_UPDATE_INTERVAL_MILLISECONDS) {
			return;
		}

		lastUpdateAt = Date.now();

		const lastIndex = $journey.location.index !== undefined ? Math.max($journey.location.index + 1, 1) : 1;

		const path = route
			.slice(0, lastIndex)
			.filter((_0, i) => i + 100 > lastIndex || i % 10 === 0)
			.concat($journey.location);

		set(path);
	});
}

export default createPathStore;
